import React from 'react'

const Footer = () => {
    return (
      <div className="footer">
        Copyright © Jaipur Jwellery Show (JJS). All Rights Reserved.
      </div>
    );
}

export default Footer